const getters = {
    loadingCount: (state) => state.loadingCount,
    isLoading: (state) => state.loadingCount > 0
};

export default getters;